export const BESTSELLER_SKUS = {
  inkSkus: ['3JB05AE', 'T2996-REM', 'PG540XL-CL541XL'],
  tonerSkus: ['CF54X-PACK', 'TN-247-PACK', 'TN1050-REM'],
};
